import React from "react";
import { format } from "lib/globalize-util";
import { merge, $ } from "glamor";
import { themeOptions } from "styles/theme";

const styles = merge(
    {
        width: "100%",
    },
    $(" .errorMessage", {
        backgroundColor: themeOptions.palette.errorLighter,
        color: themeOptions.palette.darkerGrey,
        padding: "8px",
        margin: "16px 0",
    }),
    $(" .errorHeadline", {
        color: themeOptions.palette.error,
        fontWeight: "bold",
    }),
    $(" .instructions", {
        padding: "16px 0",
    }),
);

export interface PaymentFailureContentProps {
    errors: any[];
    selections?: any[];
}

export const PaymentFailureContent = ({ errors = [], selections = [] }: PaymentFailureContentProps) => {
    if (!errors.length) {
        return null;
    }

    const errorMessages = errors.map((err, i) => {
        return (
            <div key={i} className="errorMessage">
                <p className="errorHeadline">
                    {format("Order #|orderNumber|: Payment Declined", { orderNumber: err.headline })}
                </p>
                <p>{err?.message?.error || err?.message?.err?.message || err.message}</p>
            </div>
        );
    });

    return (
        <div {...styles}>
            {selections.length === 1 && (
                <p className="instructions">
                    {format(
                        "Your order was successfully submitted but there were some errors with payment processing. View your order and try processing again with a different card.",
                    )}
                </p>
            )}
            {selections.length > 1 && (
                <p className="instructions">
                    {format(
                        "Your orders were successfully submitted but there were some errors with payment processing. View your orders and try processing again with a different card.",
                    )}
                </p>
            )}
            {errorMessages}
        </div>
    );
};
